// src/components/dialog/DlgReportResult.tsx

import { GetAppTwoTone } from '@mui/icons-material'
import {
  Button,
  Alert,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { useState } from 'react'

import { Severity } from '@/types/mui'

type Props = {
  caption?: string
  severity: Severity
  status: string
  title: string
}

export const DlgReportResult = ({
  caption = 'Zusammenfassung',
  severity,
  status,
  title,
}: Props) => {
  const [showDialog, setShowDialog] = useState(true)

  const onClose = () => setShowDialog(false)

  return (
    <Dialog open={showDialog} onClose={onClose}>
      <DialogTitle>{caption}</DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Alert severity={severity}>
          <AlertTitle>{title}</AlertTitle>

          {severity === 'success' && (
            <form method={'get'} action={status}>
              <Button type={'submit'}>
                <GetAppTwoTone /> PDF
              </Button>
            </form>
          )}

          {severity === 'error' && status}
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Fertig</Button>
      </DialogActions>
    </Dialog>
  )
}
